import { render, staticRenderFns } from "./clientNotes-table.vue?vue&type=template&id=4024e9c2&scoped=true&"
import script from "./clientNotes-table.vue?vue&type=script&lang=js&"
export * from "./clientNotes-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024e9c2",
  null
  
)

export default component.exports